import { useEffect, useState } from 'react';
import { StoreState } from '../../../store';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import { useSelector } from 'react-redux';
import { QuoteWizardForm } from '../classes';

const getFormAnswers = (state: StoreState) => {
  return state.quoteWizard.formAnswers;
};
interface DisplayFormErrorsProps {
  formErrors: { [k: QuoteWizardForm['id']]: boolean };
}
export const DisplayFormErrors = ({ formErrors }: DisplayFormErrorsProps) => {
  const formsWithAnswers = useSelector(getFormAnswers);
  const [errorForms, setErrorForms] = useState<Array<QuoteWizardForm>>([]);

  // set the forms which actually contain an error
  useEffect(() => {
    const currentErrorForms = Object.entries(formErrors).reduce(
      (acc: Array<QuoteWizardForm>, [id, errorPresent]) => {
        if (!errorPresent) {
          return acc;
        }
        const inState = formsWithAnswers[id];
        if (inState) {
          return [...acc, inState.form];
        }
        return acc;
      },
      [],
    );
    setErrorForms(sortErrorForms(currentErrorForms));
  }, [formsWithAnswers, formErrors]);

  return (
    <Collapse in={Object.values(formErrors).some((e) => e)}>
      <Alert severity='error'>
        {/* <pre>{JSON.stringify(formErrors, null, 4)}</pre> */}
        <Typography sx={{ color: 'error.main' }}>
          {Object.values(formErrors).filter((elem) => !!elem).length === 1
            ? 'One'
            : 'Several'}{' '}
          of the forms above contain errors. Please correct these before
          submitting the application.
        </Typography>
        <List>
          {errorForms.map((errorForm) => {
            return (
              <ListItem>
                <Button component='a' href={`#${errorForm.id}`}>
                  {errorForm.getName()}
                </Button>
              </ListItem>
            );
          })}
        </List>
      </Alert>
    </Collapse>
  );
};

const sortErrorForms = (
  forms: Array<QuoteWizardForm>,
): Array<QuoteWizardForm> => {
  return [...forms].sort((a, b) => {
    if (!a.policy && b.policy) {
      return -1;
    }
    if (a.policy && !b.policy) {
      return 1;
    }
    if (!a.policy && !b.policy) {
      return 0;
    }
    // Both have policy, sort by displayName
    return (a.policy?.displayName || '').localeCompare(
      b.policy?.displayName || '',
    );
  });
};
